import { IApiSuccessWrapper } from '$/types'
import { apiSlice } from 'app/services/api'
import { IEventAttribute } from 'features/Settings/types'

export const dataUpdateEventTablesApi = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDataUpdateEventTablesAttributes: build.query<IEventAttribute[], void>({
      query: () => ({
        method: 'GET',
        url: '/dataupdate/events/attributes'
      }),
      transformResponse: (res: IApiSuccessWrapper) => {
        return res.result as IEventAttribute[]
      }
    })
  })
})

export const { useGetDataUpdateEventTablesAttributesQuery } =
  dataUpdateEventTablesApi
